import { Field, Form } from 'react-final-form';
import { Button, Card, CardBody, Col, FormGroup } from 'reactstrap';
import React from 'react';
import validate, { ArmyBookImportParams } from './army-book.validate';
import { defaultMessages } from '@I18n/default';
import ReduxFormTextarea from '@Utils/ReduxFormTextarea';

export interface ArmyBookFormProps {
  onImport: (values: ArmyBookImportParams) => void;
}

const ArmyBookNewForm: React.FC<ArmyBookFormProps> = ({ onImport }) => {
  return (
    <>
    <div className="book">
      <h2 className="text-center">
        <em>Import Army book</em>
      </h2>
    </div>
    <Form
      initialValues={{}}
      subscription={{ submitting: true, pristine: true }}
      onSubmit={onImport}
      validate={validate}
    >
      {({ handleSubmit, form }) => (
        <form onSubmit={handleSubmit}>
          <Card className="card-border">
            <CardBody>
              <FormGroup row={true}>
                <Col xs="12">
                  <Field
                    name="data"
                    type="text"
                    rows={15}
                    component={ReduxFormTextarea}
                    label={defaultMessages.publicationArmyBookFormNameLabel}
                    placeHolder={defaultMessages.publicationArmyBookFormNamePlaceholder}
                  />
                </Col>
              </FormGroup>
            </CardBody>
            <div className="mb-2 text-center">
              <Button
                color="primary"
                className="ms-2"
                type="submit"
              >
                Import
              </Button>
            </div>
          </Card>
        </form>
      )}
    </Form>
    </>
  );
};

export default ArmyBookNewForm;
